<PageContainer>
	<div class="flex flex-col justify-between gap-x-12 gap-y-8 lg:flex-row">
		<div class="lg:w-1/2">
			<TitleH2 value="Kdo jsme a co děláme" />
			<div class="mt-8 flex w-full flex-col gap-6 leading-7 text-pretty text-neutral-600">
				<p>
					Jsme moderní obchodní společnost specializující se na <strong
						>pasportizaci nemovitostí</strong>
					a zpracování <strong>průkazů energetické náročnosti budov (PENB)</strong>.
				</p>
				<p>
					Pracujeme spolehlivě, přesně a efektivně. Víme, že správná dokumentace je základ nejen
					kvůli legislativě, ale především pro klid při prodeji, nákupu nebo pronájmu nemovitosti.
				</p>
				<p><strong>Na přesnosti nám záleží.</strong></p>
			</div>
		</div>
		<div class="w-full lg:w-1/2">
			<img class="w-full rounded-xl object-cover" src={office} alt="Kancelář" />
		</div>
	</div>
</PageContainer>

<script lang="ts">
	import PageContainer from '$lib/components/PageContainer.svelte';
	import TitleH2 from '$lib/components/elements/TitleH2.svelte';
	import office from '$lib/assets/images/office.webp';
</script>
